import { useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { useCreateApiKey } from 'api/ApiKeyApi';
import { ApiError } from 'services/api';
import { useModalContext } from 'utils/contexts/modal';
import { addPositiveToast, addNegativeToast } from 'modules/toastContainer';
import { fetchApiKeysRequest } from '../actions';
import { formulateCreateApiKeyPayload } from '../utils';
import { ApiKeysFormProvider } from '../contexts/ApiKeysFormProvider';
import {
  ModalState,
  MODAL_ACTION,
  NAME,
  CreateApiKeyResponsePayload,
} from './ApiKeyModal.constants';
import { ApiKeyModal } from './ApiKeyModal';

export const TEXT = {
  ID: 'api-key-create-modal',
  HEADER: 'New API key',
  BUTTON: 'Create API key',
};

const CreateModal = () => {
  const { hideModal, showModal } = useModalContext<ModalState>();
  const dispatch = useDispatch();
  const { getValues } = useFormContext();

  const { mutate } = useCreateApiKey({
    onSuccess: (data: any) => {
      const name = getValues(NAME);
      dispatch(addPositiveToast(`Successfully created ${name}.`));
      showModal({
        action: MODAL_ACTION.VIEW_API_KEY,
        createResponsePayload: data as CreateApiKeyResponsePayload,
      });
      dispatch(fetchApiKeysRequest());
    },
    onError: (e: unknown) => {
      const errorText = (e as ApiError)?.response?.data;
      dispatch(addNegativeToast(errorText));
      hideModal();
    },
  });

  const onSubmit = (values: Record<string, any>) => {
    const payload = formulateCreateApiKeyPayload(values);
    mutate(payload);
  };

  return (
    <ApiKeyModal
      id={TEXT.ID}
      headerText={TEXT.HEADER}
      buttonText={TEXT.BUTTON}
      onSubmit={onSubmit}
    />
  );
};

export const CreateApiKeyModal = () => (
  <ApiKeysFormProvider>
    <CreateModal />
  </ApiKeysFormProvider>
);
